import { render, staticRenderFns } from "./EarliestHomeworkSubmitCard.vue?vue&type=template&id=177dece2&scoped=true"
import script from "./EarliestHomeworkSubmitCard.vue?vue&type=script&lang=ts"
export * from "./EarliestHomeworkSubmitCard.vue?vue&type=script&lang=ts"
import style0 from "./EarliestHomeworkSubmitCard.vue?vue&type=style&index=0&id=177dece2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177dece2",
  null
  
)

export default component.exports